import { render, staticRenderFns } from "./AdminOrdersView.vue?vue&type=template&id=7f498b14&scoped=true"
import script from "./AdminOrdersView.vue?vue&type=script&lang=js"
export * from "./AdminOrdersView.vue?vue&type=script&lang=js"
import style0 from "./AdminOrdersView.vue?vue&type=style&index=0&id=7f498b14&prod&lang=scss&scoped=true"
import style1 from "./AdminOrdersView.vue?vue&type=style&index=1&id=7f498b14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f498b14",
  null
  
)

export default component.exports